import { useEffect, useRef, useState } from 'react';

/** A score that flips in and glows blue for a moment whenever it changes. */
export function Score({ value, className = '' }: { value: string | number; className?: string }) {
  const text = String(value);
  const prev = useRef(text);
  const [key, setKey] = useState(0);
  const [changed, setChanged] = useState(false);
  useEffect(() => {
    if (prev.current !== text) {
      prev.current = text;
      setKey((k) => k + 1);
      setChanged(true);
      const t = window.setTimeout(() => setChanged(false), 1800);
      return () => window.clearTimeout(t);
    }
  }, [text]);
  return (
    <span className={`inline-block overflow-hidden ${className}`}>
      <span key={key} className={`inline-block ${changed ? 'animate-scoreFlip' : ''}`}>{text}</span>
    </span>
  );
}
